(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class LodestarLocalization extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;
      this.summary = this.details.querySelector('summary');
      this.filterInput = this.querySelector('.lodestar-loc__filter-input');
      this.isDrawer = this.hasAttribute('data-drawer');

      this.details.addEventListener('toggle', this.onToggle.bind(this));

      if (!this.isDrawer) {
        this.onDocClick = (event) => {
          if (this.details.hasAttribute('open') && !this.contains(event.target)) this.closePanel();
        };
        document.addEventListener('click', this.onDocClick);
        this.addEventListener('focusout', () => {
          setTimeout(() => {
            if (this.details.hasAttribute('open') && !this.contains(document.activeElement)) this.closePanel();
          });
        });
        // Self-contained ESC close. Dawn's global.js binds onKeyUpEscape to
        // [id^="Details-"] summaries, but that asset is customized on this
        // theme and not mirrored here; a redundant binding is harmless.
        this.addEventListener('keyup', (event) => {
          if (event.key !== 'Escape' || !this.details.hasAttribute('open')) return;
          this.closePanel();
          if (this.summary) this.summary.focus();
        });
      }

      if (this.filterInput) {
        this.filterInput.addEventListener('input', this.filterCountries.bind(this));
        // Enter inside the filter must not implicitly submit the first country.
        // event.key covers Enter AND NumpadEnter (and mobile IMEs where
        // event.code is empty); the code check is a belt-and-braces fallback.
        this.filterInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || (event.code || '').toUpperCase().indexOf('ENTER') > -1) {
            event.preventDefault();
          }
        });
      }
    }

    disconnectedCallback() {
      if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
    }

    onToggle() {
      const open = this.details.hasAttribute('open');
      if (this.summary) this.summary.setAttribute('aria-expanded', open.toString());
      if (this.isDrawer) {
        // Dawn's MenuDrawer (global.js) binds every summary inside
        // <header-drawer>. Its click handler's 100ms setTimeout force-writes
        // aria-expanded="true" and adds 'menu-opening' even when this details
        // just CLOSED, and for reduced-motion users trapFocus() can dump focus
        // on the now-hidden list. Re-assert the real state after that write.
        clearTimeout(this.reassertTimer);
        this.reassertTimer = setTimeout(() => {
          const isOpen = this.details.hasAttribute('open');
          if (this.summary) this.summary.setAttribute('aria-expanded', isOpen.toString());
          if (!isOpen) {
            this.details.classList.remove('menu-opening');
            if (
              this.summary &&
              (document.activeElement === document.body || document.activeElement === null)
            ) {
              this.summary.focus();
            }
          }
        }, 150);
        return;
      }
      const header = document.querySelector('.header-wrapper');
      if (header) header.preventHide = open;
    }

    closePanel() {
      this.details.removeAttribute('open');
      if (this.summary) this.summary.setAttribute('aria-expanded', 'false');
    }

    normalizeString(str) {
      return str
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase();
    }

    filterCountries() {
      const query = this.normalizeString(this.filterInput.value);
      let visibleCount = 0;
      this.querySelectorAll('.lodestar-loc__list--countries > li').forEach((item) => {
        const name = item.querySelector('.lodestar-loc__name');
        const match = !query || (name && this.normalizeString(name.textContent).indexOf(query) > -1);
        item.hidden = !match;
        if (match) visibleCount++;
      });
      const liveRegion = this.querySelector('[data-loc-count]');
      if (liveRegion && window.accessibilityStrings && window.accessibilityStrings.countrySelectorSearchCount) {
        liveRegion.textContent = window.accessibilityStrings.countrySelectorSearchCount.replace('[count]', visibleCount);
      }
    }
  }

  customElements.define('lodestar-localization', LodestarLocalization);

  } catch(e) { console.error(e); }
})();
})();
